import React, { useState, useEffect, useContext, Fragment, useCallback } from 'react';

import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import Input from 'b2b-ui-components-lib/lib/components/input';
import Datepicker from 'b2b-ui-components-lib/lib/components/datePicker';
import Button from 'b2b-ui-components-lib/lib/components/button';
import Checkbox from 'b2b-ui-components-lib/lib/components/checkbox';

import FileUpload from '../FileUpload/poUpload';
import { formSchema, getDefaultValue, getDefaultFiles, ignoreKeys, purchaseOrderExpiryDateKey } from './FormControl';

import { isFormValid, getErrMsg } from 'home/view/upgrade-order/utils';

import { getCustomerDetail } from 'home/view/upgrade-order/utils';

import { CONTEXT } from 'home/view/upgrade-order/context';

import { DOCUMENT_TYPE_ENUM, TOAST_TYPE, LEAD_STATUS, ORDER_STATUS } from 'home/view/upgrade-order/constants';

import { deleteDocumentsAsync } from 'home/view/upgrade-order/services';
import { getPreviousYearDate, getRange, isFormTouched } from 'common/utils/app.utils';
import { FILE_MAX_SIZE, FILE_MAX_SIZE_MSG, ORDER_TYPE, PO_MAX_YEAR_BACK, isShiftingJourney } from 'common/constants/app.constants';
import { isOrderConfirmationUrl } from 'dedicated/services/summary.service';

const TitleComponent = React.memo(({ checked, onCheckBoxChange, leadData, order }) => {
  const nop = () => {};

  const customerDetails = getCustomerDetail(leadData);
  const isEnterprise = customerDetails?.segment === 'ENTERPRISE';

  const isChecked = isEnterprise ? true : checked;
  const onCheckBoxChangeFn = isEnterprise ? nop : onCheckBoxChange;
  const isOrderConfirmationPending = order.orderStatus === ORDER_TYPE.ORDER_CONFIRMATION_PENDING;

  return (
    <Fragment>
      <div className="upgrade-header-open">
        <div className="title pad-bottom-0">Confirm Order Details</div>
        <label className="field_label">All fields are mandatory unless marked optional.</label>
      </div>
      <ul className="upgrade-header-closed">
        <Checkbox checked={isChecked} onChange={onCheckBoxChangeFn} disabled={isOrderConfirmationUrl() || isOrderConfirmationPending}>
          <span className="check_text">Add PO details in my bill</span>
        </Checkbox>
      </ul>
    </Fragment>
  );
});

const PurchaseDetails = (props) => {
  const {
    order = {},
    updateParentForm,
    setFormStatus,
    updateOrder = () => {},
    setToast = () => {},
    leadStatus = '',
    loading = false,
    checkErrors = () => {},
    onSubmitClick = () => {},
    onCancelClick = () => {},
    isSubmitDisabled = () => {},
    isCancelDisabled = () => {},
    leadData,
    showBillingDetails,
    setShowBillingDetails,
    isOrderConfirmation
  } = props;

  const fileSchema = {
    supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
    maxFileLimit: FILE_MAX_SIZE,
    documentNames: ['PO_DOCUMENT', 'PO_DOCUMENT_2', 'PO_DOCUMENT_3'],
    documentType: DOCUMENT_TYPE_ENUM.PURCHASE_ORDER,
    allowMultiplePDFs: true
  };

  const { setToastMsg, kycToken } = useContext(CONTEXT);

  const defaultFormState = getDefaultValue(order);

  const [form, setForm] = useState(defaultFormState);
  const [accordionMeta, setAccordionMeta] = useState({
    isExpanded: false
    //isValidated: false
  });
  const [defaultFileArr, setDefaultFileArr] = useState([]);
  const [checked, setChecked] = useState(true);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  useEffect(() => {
    const closedStatus = leadStatus === LEAD_STATUS.KYC_SUBMITTED;
    if (closedStatus) {
      setAccordionMeta({
        isExpanded: false
      });
    }
  }, [leadStatus]);

  useEffect(() => {
    if (Object.keys(order).length > 0) {
      setDefaultFileArr(getDefaultFiles(order.documents));
      setForm(defaultFormState);
      setAccordionMeta({
        isExpanded: true
      });
    }
  }, [order]);

  const onCheckBoxChange = (value) => {
    const updatedFormSchema = {
      ...formSchema,
      purchaseOrderNo: {
        ...formSchema.purchaseOrderNo,
        touched: true
      },
      purchaseOrderDate: {
        ...formSchema.purchaseOrderDate,
        touched: true
      },
      purchaseOrderTotalCharges: {
        ...formSchema.purchaseOrderTotalCharges,
        touched: true
      }
    };

    setChecked(value);
    setForm(updatedFormSchema);
    // setAccordionMeta({
    //   isExpanded: value
    // });
  };

  const onPurchaseOrderNo = (value) => {
    setForm({
      ...form,
      purchaseOrderNo: {
        ...form.purchaseOrderNo,
        value,
        touched: true,
        errors: form.purchaseOrderNo.validator(value) || []
      }
    });
  };
  const onPurchaseOrderDateChange = (value, keyName) => {
    if (value) {
      setForm({
        ...form,
        [keyName]: { ...form[keyName], value, touched: true, errors: [] }
      });
      return;
    }
    setForm({
      ...form,
      [keyName]: {
        ...form[keyName],
        value,
        touched: true,
        errors: keyName === purchaseOrderExpiryDateKey ? [] : ['This field is mandatory']
      }
    });
  };

  const onPurchaseOrderTotalCharges = (value) => {
    setForm({
      ...form,
      purchaseOrderTotalCharges: {
        ...form.purchaseOrderTotalCharges,
        value,
        touched: true,
        errors: form.purchaseOrderTotalCharges.validator(value) || []
      }
    });
  };

  const onFileUpload = (files, type, uploadedFiles) => {
    setForm({ ...form, files });
    if (files) {
      setUploadedFiles(uploadedFiles);
    } else {
      setUploadedFiles([]);
    }
  };

  const onFieldBlur = (formElement, keyName) => {
    const { value, validator, errors: existingError } = formElement;
    let errors = [];
    if (typeof validator === 'function') {
      errors = validator(value) || [];
    }
    setForm({
      ...form,
      [keyName]: {
        ...form[keyName],
        value,
        errors: (errors && errors.concat(existingError)) || [],
        touched: true
      }
    });
  };

  const handlePOSubmit = () => {
    if (checked && isFormValid(form, ignoreKeys)) {
      if (order?.orderStatus !== ORDER_STATUS.ORDER_SUBMITTED) {
        updateOrder(form, true, true, true);
      }
    } else if (!checked) {
      deleteUploadedFile();
      updateOrder(form, true, false, true);
    }

    // onSubmitClick();
  };

  useEffect(() => {
    const poAmount = form && form.purchaseOrderTotalCharges && form.purchaseOrderTotalCharges.value;
    const poNumber = form && form.purchaseOrderNo && form.purchaseOrderNo.value;
    const purchaseOrderDate = form && form.purchaseOrderDate && form.purchaseOrderDate.value;
    const fileUrl = (form && form.files.value) || (form && form.files === 'success');

    const isValid = !!(poAmount && poNumber && purchaseOrderDate && fileUrl);

    if (isFormValid(form, ignoreKeys) || isValid) {
      updateParentForm({ purchaseDetail: form });
      setFormStatus((formStatus) => ({
        ...formStatus,
        purchaseDetail: true
      }));

      if (isShiftingJourney()) {
        setShowBillingDetails(true);
      }
    } else {
      updateParentForm({ purchaseDetail: null });
      setFormStatus((formStatus) => ({
        ...formStatus,
        purchaseDetail: !checked ? true : false
      }));

      if (isShiftingJourney()) {
        setShowBillingDetails(false);
      }
    }

    if (isShiftingJourney() && isFormTouched(form)) {
      setShowBillingDetails(false);
    }
  }, [form, checked]);

  const deleteUploadedFile = () => {
    Array.isArray(uploadedFiles) &&
      uploadedFiles.forEach(async (_, index) => {
        const documentName = fileSchema.documentNames[index];
        const payload = { documentType: fileSchema.documentType, documentName };

        try {
          const { res, err } = await deleteDocumentsAsync(payload, kycToken);

          if (res) {
            setUploadedFiles([]);
            setDefaultFileArr([]); // clear default files also after checkbox unchecked in PO details form
          } else if (err) {
            const errorMsg = getErrMsg(err);
            setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
            throw new Error(errorMsg);
          }
        } catch (e) {
          console.error(e);
        }
      });
  };

  // const isOrderConfirmationPending = () => {
  //   return order.orderStatus === ORDER_TYPE.ORDER_CONFIRMATION_PENDING;
  // };

  const isDisabled = () => {
    return (leadStatus === LEAD_STATUS.KYC_SUBMITTED && order.orderStatus !== ORDER_STATUS.OV_REJECTED) || isOrderConfirmationUrl() || isOrderConfirmation;
  };

  const showFooter = () => {
    return !showBillingDetails && (leadStatus === LEAD_STATUS.KYC_IN_PROGRESS || (leadStatus === LEAD_STATUS.KYC_SUBMITTED && order.orderStatus === ORDER_STATUS.OV_REJECTED));
  };

  return (
    <div className="po-details upgrade-accordion">
      <Accordion
        autoScrollOnExpand={order && order.orderStatus !== ORDER_STATUS.OV_REJECTED ? false : true}
        title={<TitleComponent checked={checked} onCheckBoxChange={onCheckBoxChange} leadData={leadData} order={order} />}
        isExpanded={accordionMeta.isExpanded}
        //isValidated={accordionMeta.isValidated}
        onExpandClick={() =>
          setAccordionMeta((accordionMeta) => ({
            ...accordionMeta,
            isExpanded: !accordionMeta.isExpanded
          }))
        }
        variant="round"
      >
        {checked && (
          <div className="accordion_body upgrade-body">
            <div className="order_details_form">
              <div className="row field_row">
                <div className="flg-lg-12 flg-md-12">
                  <div className="form_area">
                    <div className="row">
                      <div className="flg-lg-6 flg-md-6">
                        <Input
                          label="Purchase Order Number"
                          required
                          onBlur={() => onFieldBlur(form.purchaseOrderNo, 'purchaseOrderNo')}
                          errors={form.purchaseOrderNo.errors}
                          touched={form.purchaseOrderNo.touched}
                          value={form.purchaseOrderNo.value}
                          onChange={onPurchaseOrderNo}
                          disabled={isDisabled()}
                        />
                      </div>
                      <div className="flg-lg-6 flg-md-6">
                        <Datepicker
                          name="datepicker"
                          label="Purchase Order Date"
                          required={true}
                          errors={form.purchaseOrderDate.errors}
                          touched={form.purchaseOrderDate.touched}
                          value={form.purchaseOrderDate.value}
                          onChange={(value) => onPurchaseOrderDateChange(value, 'purchaseOrderDate')}
                          maxDate={new Date()}
                          minDate={getPreviousYearDate(PO_MAX_YEAR_BACK)}
                          years={getRange(getPreviousYearDate(PO_MAX_YEAR_BACK).getFullYear(), new Date().getFullYear())}
                          disabled={isDisabled()}
                        />
                      </div>

                      <div className="flg-lg-6 flg-md-6">
                        <Input
                          type="text"
                          label="Purchase Order Total Charges"
                          required
                          onBlur={() => onFieldBlur(form.purchaseOrderTotalCharges, 'purchaseOrderTotalCharges')}
                          errors={form.purchaseOrderTotalCharges.errors}
                          touched={form.purchaseOrderTotalCharges.touched}
                          value={form.purchaseOrderTotalCharges.value}
                          onChange={onPurchaseOrderTotalCharges}
                          disabled={isDisabled()}
                        />
                      </div>

                      {/* <div className="flg-lg-6 flg-md-6">
                        <Datepicker
                          name="datepicker"
                          label="Purchase Order Expiry Date (Optional)"
                          required={true}
                          errors={form.purchaseOrderExpiryDate.errors}
                          touched={form.purchaseOrderExpiryDate.touched}
                          value={form.purchaseOrderExpiryDate.value}
                          onChange={(value) => onPurchaseOrderDateChange(value, 'purchaseOrderExpiryDate')}
                          maxDate={new Date(new Date().setYear(new Date().getFullYear() + 5))}
                          minDate={new Date()}
                          years={getRange(new Date().getFullYear(), new Date().getFullYear() + 5)}
                          disabled={isDisabled()}
                        />
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {checked && (
          // <div className="accordion_footer">
          <Fragment>
            <div className="upgrade-header-open">
              <div className="title pad-bottom-0">Upload Purchase Order</div>
              <label className="field_label">You can upload up-to 3 documents.</label>
            </div>
            <FileUpload
              onFileUploadSuccess={onFileUpload}
              label="Upload Purchase Order Document (upto 3 documents)"
              supportedLabel="Supported file format is .PDF, .PNG, .JPG"
              limitLabel={FILE_MAX_SIZE_MSG}
              fileSchema={fileSchema}
              defaultFiles={defaultFileArr}
              setToast={setToast}
              disabled={isDisabled() || isOrderConfirmationUrl() || isOrderConfirmation}
              multiple={true}
            ></FileUpload>
          </Fragment>
          // </div>
        )}
        {/* {showFooter() && (
          <div className="action_button">
            <Button variant="outlinebtn" displayName="Cancel" onClick={onCancelClick} disabled={isCancelDisabled()}></Button>
            <Button displayName="Next" disabled={loading || isSubmitDisabled()} onClick={handlePOSubmit}>
              {loading && <span className="loading_icon"></span>}
            </Button>
          </div>
        )} */}
      </Accordion>
    </div>
  );
};

export default PurchaseDetails;
